"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessTaxonomyToJSON = exports.BusinessTaxonomyFromJSONTyped = exports.BusinessTaxonomyFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function BusinessTaxonomyFromJSON(json) {
    return BusinessTaxonomyFromJSONTyped(json, false);
}
exports.BusinessTaxonomyFromJSON = BusinessTaxonomyFromJSON;
function BusinessTaxonomyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'image': !(0, runtime_1.exists)(json, 'image') ? undefined : (0, _1.AssetFromJSON)(json['image']),
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'priority': json['priority'],
    };
}
exports.BusinessTaxonomyFromJSONTyped = BusinessTaxonomyFromJSONTyped;
function BusinessTaxonomyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'image': (0, _1.AssetToJSON)(value.image),
        'name': value.name,
        'description': value.description,
        'priority': value.priority,
    };
}
exports.BusinessTaxonomyToJSON = BusinessTaxonomyToJSON;
